import gql from 'graphql-tag';

export const FRAGMENT_QUOTE = gql`
  fragment quote on ContentSnippetQuoteType {
    text
    author
  }
`;
